"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimisticUnsubsribeFromBanxAdventure = exports.subscribeBanxAdventrueOptimistics = exports.unsubscribeBanxAdventrueOptimistics = exports.initializeBanxAdventureSubscription = exports.initializeBanxAdventure = exports.optimisticSubsribeToBanxAdventure = exports.banxAdventureTimestampToWeeks = exports.weeksToBanxAdventureTimestamp = void 0;
const constants_1 = require("../../../constants");
const types_1 = require("../../../types");
const anchor_1 = require("@project-serum/anchor");
const perpetual_1 = require("../../perpetual");
const weeksToBanxAdventureTimestamp = (weeks) => {
    return constants_1.BANX_ADVENTURE_START + constants_1.BANX_ADVENTURE_DURATION * weeks;
};
exports.weeksToBanxAdventureTimestamp = weeksToBanxAdventureTimestamp;
const banxAdventureTimestampToWeeks = (adventureTimestamp) => Math.floor((adventureTimestamp - constants_1.BANX_ADVENTURE_START) / constants_1.BANX_ADVENTURE_DURATION);
exports.banxAdventureTimestampToWeeks = banxAdventureTimestampToWeeks;
const optimisticSubsribeToBanxAdventure = (args) => {
    let difPartnerPoints = args.banxTokensStake.playerPointsStaked - args.adventureSubscription.stakePlayerPointsAmount;
    let difPlayerPoints = args.banxTokensStake.partnerPointsStaked - args.adventureSubscription.stakePartnerPointsAmount;
    let difTokens = args.banxTokensStake.tokensStaked - args.adventureSubscription.stakeTokensAmount;
    let difBanx = args.adventureSubscription.adventureSubscriptionState == types_1.BanxAdventureSubscriptionState.None ? args.banxTokensStake.banxNftsStakedQuantity : args.isNftStake ? 1 : 0;
    return {
        adventure: Object.assign(Object.assign({}, args.adventure), { adventureState: types_1.BanxAdventureState.Active, totalBanxSubscribed: args.adventure.totalBanxSubscribed + difBanx, totalPartnerPoints: args.adventure.totalPartnerPoints + difPartnerPoints, totalPlayerPoints: args.adventure.totalPlayerPoints + difPlayerPoints, totalTokensStaked: args.adventure.totalTokensStaked + difTokens }),
        adventureSubscription: Object.assign(Object.assign({}, args.adventureSubscription), { stakePartnerPointsAmount: args.adventureSubscription.stakePartnerPointsAmount + difPartnerPoints, stakePlayerPointsAmount: args.adventureSubscription.stakePlayerPointsAmount + difPlayerPoints, stakeTokensAmount: args.adventureSubscription.stakeTokensAmount + difTokens, stakeNftAmount: args.adventureSubscription.stakeNftAmount + difBanx, subscribedAt: (0, perpetual_1.nowInSeconds)(), adventureSubscriptionState: types_1.BanxAdventureSubscriptionState.Active, adventure: args.adventure.publicKey, banxTokenStake: args.banxTokensStake.publicKey, user: args.banxTokensStake.user }),
        banxTokensStake: Object.assign(Object.assign({}, args.banxTokensStake), { adventureSubscriptionsQuantity: args.adventureSubscription.adventureSubscriptionState == types_1.BanxAdventureSubscriptionState.None ? args.banxTokensStake.adventureSubscriptionsQuantity + 1 : args.banxTokensStake.adventureSubscriptionsQuantity })
    };
};
exports.optimisticSubsribeToBanxAdventure = optimisticSubsribeToBanxAdventure;
const initializeBanxAdventure = (week, settings) => __awaiter(void 0, void 0, void 0, function* () {
    const timestamp = (0, exports.weeksToBanxAdventureTimestamp)(week);
    const [adventure] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_PREFIX), constants_1.ENCODER.encode(timestamp.toString())], new anchor_1.web3.PublicKey(constants_1.BONDS_PROGRAM_PUBKEY));
    return {
        adventureState: types_1.BanxAdventureState.None,
        week: week,
        amountOfTokensHarvested: 0,
        periodEndingAt: timestamp + constants_1.BANX_ADVENTURE_DURATION,
        periodStartedAt: timestamp,
        publicKey: adventure.toBase58(),
        rewardsToBeDistributed: settings.tokensPerWeek,
        placeholderOne: constants_1.EMPTY_PUBKEY.toBase58(),
        tokensPerPoints: settings.tokensPerPartnerPoints,
        totalBanxSubscribed: 0,
        totalPartnerPoints: 0,
        totalPlayerPoints: 0,
        totalTokensStaked: 0,
    };
});
exports.initializeBanxAdventure = initializeBanxAdventure;
const initializeBanxAdventureSubscription = (adventure, banxTokensStake, user) => __awaiter(void 0, void 0, void 0, function* () {
    const [adventureSubscription] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), adventure.toBuffer(), user.toBuffer()], new anchor_1.web3.PublicKey(constants_1.BONDS_PROGRAM_PUBKEY));
    const subscription = {
        adventureSubscriptionState: types_1.BanxAdventureSubscriptionState.None,
        user: user.toBase58(),
        adventure: adventure.toBase58(),
        banxTokenStake: banxTokensStake.toBase58(),
        stakeTokensAmount: 0,
        stakePartnerPointsAmount: 0,
        stakePlayerPointsAmount: 0,
        subscribedAt: 0,
        unsubscribedAt: 0,
        harvestedAt: 0,
        amountOfTokensHarvested: 0,
        publicKey: adventureSubscription.toBase58(),
        stakeNftAmount: 0
    };
    return subscription;
});
exports.initializeBanxAdventureSubscription = initializeBanxAdventureSubscription;
const unsubscribeBanxAdventrueOptimistics = (optimistic, weeks, isNftUnstaked = false) => __awaiter(void 0, void 0, void 0, function* () {
    let banxTokensStake = Object.assign({}, optimistic.banxTokenStake);
    const newOptimistic = (yield Promise.all(weeks.map((week) => __awaiter(void 0, void 0, void 0, function* () {
        const timestamp = (0, exports.weeksToBanxAdventureTimestamp)(week);
        let adventureOptions = optimistic.banxAdventures.find(tempAdventure => tempAdventure.adventure && tempAdventure.adventure.periodStartedAt == timestamp);
        if (!adventureOptions || !adventureOptions.adventure || adventureOptions.adventureSubscription) {
            return;
        }
        let adventure = adventureOptions.adventure;
        let adventureSubscription = adventureOptions.adventureSubscription ? adventureOptions.adventureSubscription : (yield (0, exports.initializeBanxAdventureSubscription)(new anchor_1.web3.PublicKey(adventure.publicKey), new anchor_1.web3.PublicKey(banxTokensStake.publicKey), new anchor_1.web3.PublicKey(banxTokensStake.user)));
        let tempOptimistic = (0, exports.optimisticUnsubsribeFromBanxAdventure)({
            banxTokensStake,
            adventure,
            adventureSubscription,
            isNftUnstaked,
        });
        banxTokensStake = tempOptimistic.banxTokensStake;
        return {
            adventure: tempOptimistic.adventure,
            adventureSubscription: tempOptimistic.adventureSubscription,
        };
    })))).flat();
    const definedoptimistic = newOptimistic.filter((optimistic) => optimistic !== undefined);
    const newSubscribeBanxAdventrueOptimistics = {
        banxStakingSettings: optimistic.banxStakingSettings,
        banxTokenStake: banxTokensStake,
        banxAdventures: definedoptimistic
    };
    return newSubscribeBanxAdventrueOptimistics;
});
exports.unsubscribeBanxAdventrueOptimistics = unsubscribeBanxAdventrueOptimistics;
const subscribeBanxAdventrueOptimistics = (optimistic, weeks, isNftStake = false) => __awaiter(void 0, void 0, void 0, function* () {
    let banxTokensStake = Object.assign({}, optimistic.banxTokenStake);
    const newOptimistic = (yield Promise.all(weeks.map((week) => __awaiter(void 0, void 0, void 0, function* () {
        const timestamp = (0, exports.weeksToBanxAdventureTimestamp)(week);
        let adventureOptions = optimistic.banxAdventures.find(tempAdventure => tempAdventure.adventure && tempAdventure.adventure.periodStartedAt == timestamp);
        let adventure = (adventureOptions && adventureOptions.adventure) ? adventureOptions.adventure : yield (0, exports.initializeBanxAdventure)(week, optimistic.banxStakingSettings);
        let adventureSubscription = (adventureOptions && adventureOptions.adventureSubscription) ? adventureOptions.adventureSubscription : yield (0, exports.initializeBanxAdventureSubscription)(new anchor_1.web3.PublicKey(adventure.publicKey), new anchor_1.web3.PublicKey(banxTokensStake.publicKey), new anchor_1.web3.PublicKey(banxTokensStake.user));
        let tempOptimistic = (0, exports.optimisticSubsribeToBanxAdventure)({
            banxTokensStake,
            adventure,
            adventureSubscription,
            isNftStake,
        });
        banxTokensStake = tempOptimistic.banxTokensStake;
        return {
            adventure: tempOptimistic.adventure,
            adventureSubscription: tempOptimistic.adventureSubscription,
        };
    })))).flat();
    const newSubscribeBanxAdventrueOptimistics = {
        banxStakingSettings: optimistic.banxStakingSettings,
        banxTokenStake: banxTokensStake,
        banxAdventures: newOptimistic
    };
    return newSubscribeBanxAdventrueOptimistics;
});
exports.subscribeBanxAdventrueOptimistics = subscribeBanxAdventrueOptimistics;
const optimisticUnsubsribeFromBanxAdventure = (args) => {
    let difPartnerPoints = args.banxTokensStake.playerPointsStaked - args.adventureSubscription.stakePlayerPointsAmount;
    let difPlayerPoints = args.banxTokensStake.partnerPointsStaked - args.adventureSubscription.stakePartnerPointsAmount;
    let difTokens = args.banxTokensStake.tokensStaked - args.adventureSubscription.stakeTokensAmount;
    let difBanx = args.isNftUnstaked ? -1 : 0;
    return {
        adventure: Object.assign(Object.assign({}, args.adventure), { totalBanxSubscribed: args.adventure.totalBanxSubscribed + difBanx, totalPartnerPoints: args.adventure.totalPartnerPoints + difPartnerPoints, totalPlayerPoints: args.adventure.totalPlayerPoints + difPlayerPoints, totalTokensStaked: args.adventure.totalTokensStaked + difTokens }),
        adventureSubscription: Object.assign(Object.assign({}, args.adventureSubscription), { stakePartnerPointsAmount: args.adventureSubscription.stakePartnerPointsAmount + difPartnerPoints, stakePlayerPointsAmount: args.adventureSubscription.stakePlayerPointsAmount + difPlayerPoints, stakeTokensAmount: args.adventureSubscription.stakeTokensAmount + difTokens, subscribedAt: (0, perpetual_1.nowInSeconds)(), adventure: args.adventure.publicKey, banxTokenStake: args.banxTokensStake.publicKey, user: args.banxTokensStake.user }),
        banxTokensStake: Object.assign(Object.assign({}, args.banxTokensStake), { adventureSubscriptionsQuantity: args.banxTokensStake.banxStakeState == types_1.BanxTokenStakeState.Unstaked ? args.banxTokensStake.adventureSubscriptionsQuantity - 1 : args.banxTokensStake.adventureSubscriptionsQuantity })
    };
};
exports.optimisticUnsubsribeFromBanxAdventure = optimisticUnsubsribeFromBanxAdventure;
